import axios from "axios";
import { CONTACT_US_URL } from "./api";

export function getAll() {
  return axios.get(CONTACT_US_URL);
}



// WEBPACK FOOTER //
// ./src/service/contact-us.js